export default "__VITE_ASSET__TfM6wteK__"